import type CommonStyles from '@/styles/next-styles/common'

import colors from '../colors.json'

const commonStyles: CommonStyles = {
  boxBgColor: colors.gray['50'],
}

export default commonStyles
